<template>
    <a-spin id="LookReport" :spinning="boxSpinning">
        <a-card title="基本信息" :bordered="false">
            <a-page-header style="border: 1px solid rgb(235, 237, 240);margin-bottom: 30px;"
                           :title="reportInfo.nameCN"
                           :subTitle="reportInfo.nameEN"
                           :backIcon="false">
                <template slot="extra">
                  <a-button v-if="[1, 2].includes(reportInfo.status)" type="link" key="3"> 报告生成中 </a-button>
                  <a-button v-if="reportInfo.wordReportUrl" type="primary" ghost key="2">
                    <a download :href="reportInfo.wordReportUrl | filterUrl">下载报告</a>
                  </a-button>
                    <a-button @click="copyGroupReport" key="1">
                        拷贝报告
                    </a-button>
                </template>
                <a-descriptions size="small" :column="3">
                    <a-descriptions-item label="项目名称">
                        {{ reportInfo.projectName }}
                    </a-descriptions-item>
                    <a-descriptions-item label="报告类型">
                        {{ reportInfo.reportType === 1 ? "团体测评报告" : "团体对比报告" }}
                    </a-descriptions-item>
                    <a-descriptions-item label="机构名称">
                        {{ reportInfo.organizationName && reportInfo.organizationName.join("，") }}
                    </a-descriptions-item>
                    <a-descriptions-item label="报告日期">
                        {{ reportInfo.reportTime }}
                    </a-descriptions-item>
                    <a-descriptions-item label="创建时间">
                        {{ reportInfo.createTime }}
                    </a-descriptions-item>
                </a-descriptions>
            </a-page-header>
        </a-card>
        <a-card title="项目信息" :bordered="false">
            <StepsSecond :IsDetails="true"/>
        </a-card>
        <a-card title="能力配置" :bordered="false">
            <StepsThird :IsDetails="true"/>
        </a-card>
        <a-card title="参数配置" :bordered="false">
            <StepsFourth :IsDetails="true"/>
        </a-card>
    </a-spin>
</template>

<script>
    import StepsSecond from "../createReport/steps/StepsSecond";
    import StepsThird from "../createReport/steps/StepsThird";
    import StepsFourth from "../createReport/steps/StepsFourth";
    import $Bus from "@/pages/projectImpl/js/eventBus";

    export default {
        name: "LookReport",
        components: {StepsSecond,StepsThird,StepsFourth},
        props: {reportInfo: {}},
        data() {
            return {
                boxSpinning: false
            }
        },
        methods: {
            //拷贝报告
            copyGroupReport(){
                this.$http.GroupReport.copyGroupReport(new URLSearchParams({
                    groupReportId: this.reportInfo.id
                })).then(res => {
                    this.$message.success(res.message);
                    $Bus.$emit("copyReport", res.data);
                })
            }
        }
    }
</script>

<style lang="less" scoped>
    #LookReport {
        height: calc(100vh - 105px);
        scrollbar-width: none; /* firefox */
        -ms-overflow-style: none; /* IE 10+ */
        overflow-x: hidden;
        overflow-y: auto;
        box-sizing: border-box;
        &::-webkit-scrollbar {
            display: none; /* Chrome Safari */
        }
    }

</style>
